import React from 'react'
import HHTextField from 'components/form-fields/v5/HHTextField'
import T from 'T'
import PropTypes from 'prop-types'
import { PAYMENT_METHODS } from 'settings/constants/payment'
import RenderPaymentIframe from 'components/common/payments/RenderPaymentIframe'
import CardInformationInvalidAlert from 'components/payments/CardInformationInvalidAlert'
import { Grid } from '@mui/material'

const { CREDIT_CARD } = PAYMENT_METHODS

const RenderCreditCardFields = ({
  cardHolderName,
  onChange,
  onNewCardTokenChange,
  cardHolderNameError,
  showInvalidFormAlert,
  cardHolderNameInputRef,
}) => {
  return (
    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12}>
      <HHTextField
        inputRef={cardHolderNameInputRef}
        label={T.CARDHOLDER_NAME}
        required
        helperText={cardHolderNameError}
        error={Boolean(cardHolderNameError)}
        placeholder="John Doe"
        fullWidth
        value={cardHolderName}
        onChange={event => onChange('cardHolderName', event.target.value)}
      />
      {showInvalidFormAlert && <CardInformationInvalidAlert isCreditCardForm />}

      <RenderPaymentIframe type={CREDIT_CARD} callback={onNewCardTokenChange} />
    </Grid>
  )
}

RenderCreditCardFields.propTypes = {
  cardHolderName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onNewCardTokenChange: PropTypes.func.isRequired,
  cardHolderNameError: PropTypes.string,
  showInvalidFormAlert: PropTypes.bool.isRequired,
  cardHolderNameInputRef: PropTypes.object.isRequired,
}

export default RenderCreditCardFields
